import config from 'config'
import { connect } from 'react-redux'
import { selectRoomById } from 'ducks/chat/selectors/rooms'
import View from './view'

const { facebookMessengerUrl } = config

const select = (state, props) => {
  const room = selectRoomById(state, props.roomId)

  const { bridgeEvent } = room

  return {
    facebookLink: `${facebookMessengerUrl}/?asset_id=${
      bridgeEvent.recipient_id
    }&selected_item_id=${bridgeEvent.sender_id}`,
  }
}

export default connect(select)(View)
